export const BASIC_DATE = 'dd.MM.yyyy';
export const HUMAN_DATE = 'yyyy MMM dd';
export const FULL_HUMAN_DATE_TIME = `${HUMAN_DATE}, HH:mm aa`;
export const SERVER_DATE = 'yyyy-MM-dd';
export const SERVER_TIME = 'HH:mm:ssXXX';
export const SERVER_DATE_TIME = `${SERVER_DATE}'T'${SERVER_TIME}`;
